import AddIcon from "@mui/icons-material/AddRounded";
import { Button, Stack, TextField, Typography } from "@mui/material";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import ApprovalConfigurationContext from "./ApprovalConfigurationContext";
import { addRuleAction, setEditedStepNameAction } from "./approvalConfigurationState";
import EditApprovalRuleCard from "./EditApprovalRuleCard";

const EditApprovalStepSection = () => {
  const { state, setState, editedStepValidationResults } = useDefinedContext(ApprovalConfigurationContext);

  if (state.editedStep === undefined) {
    return null;
  }

  return (
    <Stack spacing={2}>
      <TextField
        fullWidth
        label="Name"
        value={state.editedStep.name}
        onChange={(e) => setState(setEditedStepNameAction(e.target.value))}
        error={!editedStepValidationResults?.name.isValid && state.isEditedStepDirty}
        helperText={editedStepValidationResults?.name.error}
      />
      <Typography variant="subtitle1" sx={{ pt: 2 }}>
        Approval Rules
      </Typography>
      {state.editedStep.rules.length === 0 && (
        <Typography color="textSecondary" sx={{ textAlign: "center" }}>
          Please add at least one approval rule
        </Typography>
      )}
      {state.editedStep.rules.length > 0 && (
        <Stack spacing={2}>
          {state.editedStep.rules.map((rule, index) => (
            <EditApprovalRuleCard key={state.editedRuleKeys?.[index]} rule={rule} ruleIndex={index} />
          ))}
        </Stack>
      )}
      <Button
        variant="text"
        color="primary"
        sx={{ width: "fit-content", alignSelf: "center" }}
        startIcon={<AddIcon />}
        onClick={() => setState(addRuleAction())}
      >
        Add Rule
      </Button>
    </Stack>
  );
};

export default EditApprovalStepSection;
